export default "__VITE_ASSET__8484cbfd__"